import { call, put, takeLatest, take } from "redux-saga/effects";
import api from "../api/api";
import SearchApi from "../api/SearchApi";
import { incrementPostViewsMP } from "../services/mixpanel";
import { shouldWaitOnAuthDone } from "../sagas/AuthSaga";
import { searchPostsSuccess, searchPostsFailed } from "../actions/searchActions";

export function* handleSearchPostsRequests(action) {
  try {
    const { searchQuery, limit, pagingToken, override } = action;
    let request = SearchApi.getSearchPostsUrl({
      searchQuery,
      limit,
      pagingToken,
    });

    if (yield shouldWaitOnAuthDone()) {
      yield take("FIREBASE_AUTH_DONE");
    }
    const results = yield call(api.get, request.url, request.config);
    yield put(searchPostsSuccess({ ...results.data, searchQuery, limit, override }));
    incrementPostViewsMP(results.data.length);
  } catch (error) {
    yield put(searchPostsFailed({ error }));
  }
}

export function* watchSearchRequests() {
  yield takeLatest("SEARCH_POSTS_REQUEST", handleSearchPostsRequests);
}

export default watchSearchRequests;



// WEBPACK FOOTER //
// ./src/sagas/SearchSaga.js